import { a as e, n as t, o as n } from "./dist-BCa5HPz5.js";
import { ApolloClient as r, ApolloProvider as i, InMemoryCache as a, createHttpLink as o, from as s } from "@apollo/client";
import { createPersistedQueryLink as c } from "@apollo/client/link/persisted-queries";
import { RetryLink as l } from "@apollo/client/link/retry";
import { setContext as u } from "@apollo/client/link/context";
import { authManager as d } from "lib-shared-auth";
import { config as f } from "lib-shared-backend-config";
import * as p from "react";
import m, { Suspense as h, createContext as g, createElement as _, lazy as v, useCallback as y, useContext as b, useEffect as x, useLayoutEffect as S, useMemo as C, useRef as w, useState as T } from "react";
import { jsx as E, jsxs as D } from "react/jsx-runtime";
import { Text as ee } from "@dixa/lib-shared-habla";
import "classnames";
import { Sentry as te, SentryTeam as ne } from "lib-shared-sentry";
import { UNSAFE_DataRouterContext as re, UNSAFE_NavigationContext as ie, useLocation as ae, useNavigate as oe, useRoutes as se } from "react-router-dom";
// ../../../node_modules/crypto-hash/utilities.js
var ce = (e) => {
	let t = new DataView(e), n = "";
	for (let e = 0; e < t.byteLength; e += 4) n += t.getUint32(e).toString(16).padStart(8, "0");
	return n;
}, le = ((e) => async (t, { outputFormat: n = "hex" } = {}) => {
	typeof t == "string" && (t = new globalThis.TextEncoder().encode(t));
	let r = await globalThis.crypto.subtle.digest(e, t);
	return n === "hex" ? ce(r) : r;
})("SHA-256"), ue = "authData";
async function O() {
	await d.getAuthData();
	let e = localStorage.getItem(ue);
	return e ? JSON.parse(e) : null;
}
async function de() {
	return `Bearer ${(await O())?.access_token}`;
}
// ../utils/src/apollo.ts
function fe() {
	return u(async (e, { headers: t }) => {
		let n = await de();
		return { headers: {
			...t,
			authorization: n
		} };
	});
}
// ../delivery-common/src/apolloClient.ts
var pe = "beta";
function me() {
	return o({ uri: `${f.url.knowledgeApi}/delivery/api/${pe}/graphql` });
}
var he = new a({ typePolicies: {
	ArticleSearchQueries: { merge: (e, t, { mergeObjects: n }) => n(e, t) },
	Query: { fields: {
		suggestions: { merge: !0 },
		knowledgeBase: { merge: !0 }
	} }
} }), k;
function ge() {
	if (!k) {
		let e = new l({
			delay: {
				initial: 1e3,
				max: 1e4
			},
			attempts: { max: 3 }
		}), t = s([
			c({
				sha256: le,
				useGETForHashedQueries: !1
			}),
			fe(),
			e,
			me()
		].filter(Boolean));
		k = new r({
			link: t,
			cache: he,
			assumeImmutableResults: !0,
			defaultOptions: { query: { canonizeResults: !0 } },
			connectToDevTools: !0
		});
	}
	return k;
}
// ../modal/src/Context.tsx
var _e = g({
	hideModal: () => {},
	showModal: () => {}
});
function ve({ children: e }) {
	let [t, n] = T(null), r = y((e, t) => {
		n({
			modal: e,
			props: t
		});
	}, []), i = y(() => n(null), []), [a, o] = t ? [t.modal, t.props] : [];
	return /* @__PURE__ */ D(_e.Provider, {
		value: {
			showModal: r,
			hideModal: i
		},
		children: [e, /* @__PURE__ */ E(h, {
			fallback: null,
			children: a && /* @__PURE__ */ E(a, { ...o })
		})]
	});
}
// ../utils/src/components/bugTracking.tsx
function ye({ children: e, fallback: t }) {
	function n(e) {
		te.captureException(e, { tags: { team: ne.Knowledge } });
	}
	return /* @__PURE__ */ E(te.ErrorBoundary, {
		fallback: t,
		onError: n,
		children: e
	});
}
var be = { message: "_message_8a2au_1" };
// ../utils/src/components/knowledgeErrorPlaceholder.tsx
function xe({ message: e }) {
	return /* @__PURE__ */ E(ee.Paragraph, {
		className: be.message,
		variant: "4",
		subdued: !0,
		children: e || "Something went wrong, please reload and try again. If this issue persists, please contact support."
	});
}
// ../utils/src/contexts/notification.tsx
var Se = g((e) => {
	console.log("Notification: ", e);
});
Se.displayName = "NotificationContext";
// builtin:esm-external-require-react
var A = /* @__PURE__ */ n(((e, t) => {
	t.exports = Object.prototype.hasOwnProperty.call(p, "module.exports") ? p["module.exports"] : { ...p };
})), Ce = /* @__PURE__ */ n(((e) => {
	var t = A();
	function n(e, t) {
		return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
	}
	var r = typeof Object.is == "function" ? Object.is : n, i = t.useState, a = t.useEffect, o = t.useLayoutEffect, s = t.useDebugValue;
	function c(e, t) {
		var n = t(), r = i({ inst: {
			value: n,
			getSnapshot: t
		} }), c = r[0].inst, u = r[1];
		return o(function() {
			c.value = n, c.getSnapshot = t, l(c) && u({ inst: c });
		}, [
			e,
			n,
			t
		]), a(function() {
			return l(c) && u({ inst: c }), e(function() {
				l(c) && u({ inst: c });
			});
		}, [e]), s(n), n;
	}
	function l(e) {
		var t = e.getSnapshot;
		e = e.value;
		try {
			var n = t();
			return !r(e, n);
		} catch {
			return !0;
		}
	}
	function u(e, t) {
		return t();
	}
	var d = typeof window > "u" || window.document === void 0 || window.document.createElement === void 0 ? u : c;
	e.useSyncExternalStore = t.useSyncExternalStore === void 0 ? d : t.useSyncExternalStore;
})), we = /* @__PURE__ */ n(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		function t(e, t) {
			return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
		}
		function n(e, t) {
			d || a.startTransition === void 0 || (d = !0, console.error("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
			var n = t();
			if (!f) {
				var i = t();
				o(n, i) || (console.error("The result of getSnapshot should be cached to avoid an infinite loop"), f = !0);
			}
			i = s({ inst: {
				value: n,
				getSnapshot: t
			} });
			var p = i[0].inst, m = i[1];
			return l(function() {
				p.value = n, p.getSnapshot = t, r(p) && m({ inst: p });
			}, [
				e,
				n,
				t
			]), c(function() {
				return r(p) && m({ inst: p }), e(function() {
					r(p) && m({ inst: p });
				});
			}, [e]), u(n), n;
		}
		function r(e) {
			var t = e.getSnapshot;
			e = e.value;
			try {
				var n = t();
				return !o(e, n);
			} catch {
				return !0;
			}
		}
		function i(e, t) {
			return t();
		}
		typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
		var a = A(), o = typeof Object.is == "function" ? Object.is : t, s = a.useState, c = a.useEffect, l = a.useLayoutEffect, u = a.useDebugValue, d = !1, f = !1, p = typeof window > "u" || window.document === void 0 || window.document.createElement === void 0 ? i : n;
		e.useSyncExternalStore = a.useSyncExternalStore === void 0 ? p : a.useSyncExternalStore, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
	})();
}));
(/* @__PURE__ */ n(((e, t) => {
	t.exports = process.env.NODE_ENV === "production" ? Ce() : we();
})))();
var j = Object.prototype.hasOwnProperty;
function M(e, t) {
	var n, r;
	if (e === t) return !0;
	if (e && t && (n = e.constructor) === t.constructor) {
		if (n === Date) return e.getTime() === t.getTime();
		if (n === RegExp) return e.toString() === t.toString();
		if (n === Array) {
			if ((r = e.length) === t.length) for (; r-- && M(e[r], t[r]););
			return r === -1;
		}
		if (!n || typeof e == "object") {
			for (n in r = 0, e) if (j.call(e, n) && ++r && !j.call(t, n) || !(n in t) || !M(e[n], t[n])) return !1;
			return Object.keys(t).length === r;
		}
	}
	return e !== e && t !== t;
}
// ../../../node_modules/swr/dist/_internal/config-context-12s-fLme8m6q.mjs
var N = /* @__PURE__ */ new WeakMap(), P = () => {}, F = Object, I = (e) => e === void 0, L = (e) => typeof e == "function", R = (e, t) => ({
	...e,
	...t
}), Te = (e) => L(e.then), z = {}, B = {}, V = "undefined", H = typeof window != V, U = typeof document != V, Ee = H && "Deno" in window, De = (e, t) => {
	let n = N.get(e);
	return [
		() => !I(t) && e.get(t) || z,
		(r) => {
			if (!I(t)) {
				let i = e.get(t);
				t in B || (B[t] = i), n[5](t, R(i, r), i || z);
			}
		},
		n[6],
		() => !I(t) && t in B ? B[t] : !I(t) && e.get(t) || z
	];
}, W = !0, Oe = () => W, [G, K] = H && window.addEventListener ? [window.addEventListener.bind(window), window.removeEventListener.bind(window)] : [P, P], ke = () => {
	let e = U && document.visibilityState;
	return I(e) || e !== "hidden";
}, Ae = (e) => (U && document.addEventListener("visibilitychange", e), G("focus", e), () => {
	U && document.removeEventListener("visibilitychange", e), K("focus", e);
}), je = (e) => {
	let t = () => {
		W = !0, e();
	}, n = () => {
		W = !1;
	};
	return G("online", t), G("offline", n), () => {
		K("online", t), K("offline", n);
	};
}, Me = {
	isOnline: Oe,
	isVisible: ke
}, Ne = {
	initFocus: Ae,
	initReconnect: je
};
m.useId;
var q = !H || Ee, Pe = q ? x : S, J = typeof navigator < "u" && navigator.connection, Fe = !q && J && (["slow-2g", "2g"].includes(J.effectiveType) || J.saveData), Y = /* @__PURE__ */ new WeakMap(), Ie = (e) => F.prototype.toString.call(e), X = (e, t) => e === `[object ${t}]`, Le = 0, Z = (e) => {
	let t = typeof e, n = Ie(e), r = X(n, "Date"), i = X(n, "RegExp"), a = X(n, "Object"), o, s;
	if (F(e) === e && !r && !i) {
		if (o = Y.get(e), o) return o;
		if (o = ++Le + "~", Y.set(e, o), Array.isArray(e)) {
			for (o = "@", s = 0; s < e.length; s++) o += Z(e[s]) + ",";
			Y.set(e, o);
		}
		if (a) {
			o = "#";
			let t = F.keys(e).sort();
			for (; !I(s = t.pop());) I(e[s]) || (o += s + ":" + Z(e[s]) + ",");
			Y.set(e, o);
		}
	} else o = r ? e.toJSON() : t == "symbol" ? e.toString() : t == "string" ? JSON.stringify(e) : "" + e;
	return o;
}, Re = (e) => {
	if (L(e)) try {
		e = e();
	} catch {
		e = "";
	}
	let t = e;
	return e = typeof e == "string" ? e : (Array.isArray(e) ? e.length : e) ? Z(e) : "", [e, t];
}, ze = 0, Be = () => ++ze;
async function Ve(...e) {
	let [t, n, r, i] = e, a = R({
		populateCache: !0,
		throwOnError: !0
	}, typeof i == "boolean" ? { revalidate: i } : i || {}), o = a.populateCache, s = a.rollbackOnError, c = a.optimisticData, l = (e) => typeof s == "function" ? s(e) : s !== !1, u = a.throwOnError;
	if (L(n)) {
		let e = n, r = [], i = t.keys();
		for (let n of i) !/^\$(inf|sub)\$/.test(n) && e(t.get(n)._k) && r.push(n);
		return Promise.all(r.map(d));
	}
	return d(n);
	async function d(n) {
		let [i] = Re(n);
		if (!i) return;
		let [s, d] = De(t, i), [f, p, m, h] = N.get(t), g = () => {
			let e = f[i];
			return (L(a.revalidate) ? a.revalidate(s().data, n) : a.revalidate !== !1) && (delete m[i], delete h[i], e && e[0]) ? e[0](2).then(() => s().data) : s().data;
		};
		if (e.length < 3) return g();
		let _ = r, v, y = !1, b = Be();
		p[i] = [b, 0];
		let x = !I(c), S = s(), C = S.data, w = S._c, T = I(w) ? C : w;
		if (x && (c = L(c) ? c(T, C) : c, d({
			data: c,
			_c: T
		})), L(_)) try {
			_ = _(T);
		} catch (e) {
			v = e, y = !0;
		}
		if (_ && Te(_)) {
			if (_ = await _.catch((e) => {
				v = e, y = !0;
			}), b !== p[i][0]) {
				if (y) throw v;
				return _;
			}
			y && x && l(v) && (o = !0, d({
				data: T,
				_c: void 0
			}));
		}
		if (o && (y || (L(o) ? d({
			data: o(_, T),
			error: void 0,
			_c: void 0
		}) : d({
			data: _,
			error: void 0,
			_c: void 0
		}))), p[i][1] = Be(), Promise.resolve(g()).then(() => {
			d({ _c: void 0 });
		}), y) {
			if (u) throw v;
		} else return _;
	}
}
var He = (e, t) => {
	for (let n in e) e[n][0] && e[n][0](t);
}, Ue = (e, t) => {
	if (!N.has(e)) {
		let n = R(Ne, t), r = Object.create(null), i = Ve.bind(void 0, e), a = P, o = Object.create(null), s = (e, t) => {
			let n = o[e] || [];
			return o[e] = n, n.push(t), () => {
				let e = n.indexOf(t);
				e >= 0 && (n[e] = n[n.length - 1], n.pop());
			};
		}, c = (t, n, r) => {
			e.set(t, n);
			let i = o[t];
			if (i) for (let e of i) e(n, r);
		}, l = () => {
			if (!N.has(e) && (N.set(e, [
				r,
				Object.create(null),
				Object.create(null),
				Object.create(null),
				i,
				c,
				s
			]), !q)) {
				let t = n.initFocus(setTimeout.bind(void 0, He.bind(void 0, r, 0))), i = n.initReconnect(setTimeout.bind(void 0, He.bind(void 0, r, 1)));
				a = () => {
					t && t(), i && i(), N.delete(e);
				};
			}
		};
		return l(), [
			e,
			i,
			l,
			a
		];
	}
	return [e, N.get(e)[4]];
}, We = (e, t, n, r, i) => {
	let a = n.errorRetryCount, o = i.retryCount, s = ~~((Math.random() + .5) * (1 << (o < 8 ? o : 8))) * n.errorRetryInterval;
	!I(a) && o > a || setTimeout(r, s, i);
}, Ge = M, [Q, Ke] = Ue(/* @__PURE__ */ new Map()), qe = R({
	onLoadingSlow: P,
	onSuccess: P,
	onError: P,
	onErrorRetry: We,
	onDiscarded: P,
	revalidateOnFocus: !0,
	revalidateOnReconnect: !0,
	revalidateIfStale: !0,
	shouldRetryOnError: !0,
	errorRetryInterval: Fe ? 1e4 : 5e3,
	focusThrottleInterval: 5e3,
	dedupingInterval: 2e3,
	loadingTimeout: Fe ? 5e3 : 3e3,
	compare: Ge,
	isPaused: () => !1,
	cache: Q,
	mutate: Ke,
	fallback: {}
}, Me), Je = (e, t) => {
	let n = R(e, t);
	if (t) {
		let { use: r, fallback: i } = e, { use: a, fallback: o } = t;
		r && a && (n.use = r.concat(a)), i && o && (n.fallback = R(i, o));
	}
	return n;
}, Ye = g({}), Xe = (e) => {
	let { value: t } = e, n = b(Ye), r = L(t), i = C(() => r ? t(n) : t, [
		r,
		n,
		t
	]), a = C(() => r ? i : Je(n, i), [
		r,
		n,
		i
	]), o = i && i.provider, s = w(void 0);
	o && !s.current && (s.current = Ue(o(a.cache || Q), i));
	let c = s.current;
	return c && (a.cache = c[0], a.mutate = c[1]), Pe(() => {
		if (c) return c[2] && c[2](), c[3];
	}, []), _(Ye.Provider, R(e, { value: a }));
}, Ze = H && window.__SWR_DEVTOOLS_USE__;
(Ze ? window.__SWR_DEVTOOLS_USE__ : []).concat((e) => (t, n, r) => e(t, n && ((...e) => {
	let [r] = Re(t), [, , , i] = N.get(Q);
	if (r.startsWith("$inf$")) return n(...e);
	let a = i[r];
	return I(a) ? n(...e) : (delete i[r], a);
}), r)), Ze && (window.__SWR_DEVTOOLS_REACT__ = m), m.use;
// ../../../node_modules/swr/dist/index/index.mjs
var Qe = Promise.resolve(void 0);
Qe.status = "fulfilled", Qe.value = void 0;
var $e = F.defineProperty(Xe, "defaultValue", { value: qe }), $;
function et() {
	return $ || ($ = async function(e, t) {
		let n = await O(), r = await fetch(tt({
			path: typeof e == "string" ? e : e.path,
			params: typeof e == "string" ? void 0 : e.params
		}), {
			mode: "cors",
			method: typeof e == "string" || !e.method ? "GET" : e.method,
			headers: {
				"content-type": "application/json",
				authorization: `Basic ${window.btoa(`token:${n?.access_token}`)}`
			},
			...typeof e != "string" && e.method !== "GET" && t?.arg?.body ? { body: JSON.stringify(t.arg.body) } : {}
		});
		function i(e) {
			let t = /* @__PURE__ */ Error("An error occured during REST request.");
			throw t.cause = {
				errors: e?.errors ?? [],
				statusCode: r.status
			}, t;
		}
		if (t?.arg.streamingFunction) {
			r.ok || i(await r.json()), await t.arg.streamingFunction(r);
			return;
		}
		let a = await r.json();
		return r.ok || i(a), a;
	}, $);
}
function tt({ path: e, params: t }) {
	let n = t ? "?" + new URLSearchParams(t) : "";
	return `${f.url.rest}/${e}${n}`;
}
// ../utils/src/contexts/restConfig.tsx
function nt({ children: e }) {
	let t = C(() => et(), []);
	return /* @__PURE__ */ D($e, {
		value: { fetcher: t },
		children: [e, " "]
	});
}
// ../../../node_modules/use-query-params/adapters/react-router-6/index.js
var rt = ({ children: e }) => {
	let { navigator: t } = b(ie), n = oe(), r = b(re)?.router, i = ae();
	return e({
		replace(e) {
			n(e.search || "?", {
				replace: !0,
				state: e.state
			});
		},
		push(e) {
			n(e.search || "?", {
				replace: !1,
				state: e.state
			});
		},
		get location() {
			return r?.state?.location ?? t?.location ?? i;
		}
	});
}, it = v(() => import("./home-BJrkq0Nw.js")), at = v(() => import("./collection-OxEiFkiE.js")), ot = v(() => import("./noArticleSelected-I9mJHicx.js")), st = v(() => import("./article-Br6veXa4.js")), ct = [{
	path: "",
	element: /* @__PURE__ */ E(it, {})
}, {
	path: "/collection/:collectionId",
	element: /* @__PURE__ */ E(at, {}),
	children: [{
		index: !0,
		element: /* @__PURE__ */ E(ot, {})
	}, {
		path: "/collection/:collectionId/article/:articleId",
		element: /* @__PURE__ */ E(st, {})
	}]
}];
// src/index.tsx
function lt() {
	return se(ct);
}
var ut = ({ notify: n }) => {
	let r = ge();
	return /* @__PURE__ */ E(ye, {
		fallback: /* @__PURE__ */ E(xe, {}),
		children: /* @__PURE__ */ E(nt, { children: /* @__PURE__ */ E(Se.Provider, {
			value: n,
			children: /* @__PURE__ */ E(i, {
				client: r,
				children: /* @__PURE__ */ E(h, {
					fallback: /* @__PURE__ */ E(e, {}),
					children: /* @__PURE__ */ E(t, {
						adapter: rt,
						children: /* @__PURE__ */ E(ve, { children: /* @__PURE__ */ E(lt, {}) })
					})
				})
			})
		}) })
	});
};
export { A as n, ut as t };

//# sourceMappingURL=src-B-Sx1C0n.js.map